import React from 'react';
import Header from './Header';

const NoQuestions = () => {
    return (
  <div className="transcribed-consultation-form">
    <Header />
    <div className="mt-0 container">
      <div className="row justify-content-md-center g-3">
        <div className="col-12">
          <div className="w-form fade-in">
            <div className="row g-5">
              <div className="col-12 text-center">
                <div className="alert alert-info" role="alert">
                  <h4 className="alert-heading">No Questions Available</h4>
                  <p>This form doesn't contain any questions yet.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    );
};

export default NoQuestions;